import React from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";
import Helmet from "react-helmet";
import Pdf from "../../assets/qprints-resale-marketplace-seller.pdf";

const Home = ({}) => {
  return (
    <div>
      <Helmet title="Home" />
      <div style={{ width: "800px", float: "left" }}>
        <h1>FBQ Quick Links</h1>
        <p>
          Choose from the main navigation links above, or one of the quick link
          buttons below:
        </p>
        <div>
          <Link to="/bulk-orders/create">
            <Button size="large" type="primary">
              Create an Order
            </Button>
          </Link>
          {"   "}
          <Link to="/bulk-mapping">
            <Button type="primary" size="large">
              Bulk Mapping
            </Button>
          </Link>
          {"   "}
          <Link to="/mappings/new">
            <Button type="primary" size="large">
              Single Mapping
            </Button>
          </Link>
        </div>
        <div style={{ paddingTop: "40px" }}>
          <h2>Pricing Info</h2>
          <p>
            We offer a limited number of print sizes, primarily on Luster finish
            paper. If you would like us to offer a size not listed please let us
            know and we will see if we can offer it.
          </p>

          <table>
            <tbody>
              <tr>
                <th style={{ width: "70px" }}>Size</th>
                <th style={{ width: "70px" }}>Price</th>
                <th style={{ width: "170px" }}>Price - 2400 or more*</th>
              </tr>
              <tr>
                <td>8x10</td>
                <td>$.70</td>
                <td>$.68</td>
              </tr>
            </tbody>
          </table>
          <br />
          <table>
            <tbody>
              <tr>
                <th style={{ width: "70px" }}>Size</th>
                <th style={{ width: "70px" }}>Price</th>
                <th style={{ width: "170px" }}>Price - 1100 or more*</th>
              </tr>
              <tr>
                <td>11x14</td>
                <td>$1.85</td>
                <td>$1.70</td>
              </tr>
            </tbody>
          </table>
          <p style={{ paddingTop: "10px" }}>
            * Quantity pricing is now available for 8x10s and 11x14s, only
            within this ordering system. Any orders reaching the quantity breaks
            may take slightly longer to print, and may ship via UPS ground which
            usually takes longer than USPS. If you are in a hurry for your order
            and need it to ship via USPS please send us an email separately and
            we can remove the discount and process the order normally.
          </p>
          <p>
            <b>Other Sizes:</b>
          </p>
          <table>
            <tbody>
              <tr>
                <th style={{ width: "70px" }}>Size</th>
                <th style={{ width: "70px" }}>Price</th>
              </tr>
              <tr>
                <td>5x7</td>
                <td>$.60</td>
              </tr>
              <tr>
                <td>12x16</td>
                <td>6.00</td>
              </tr>
              <tr>
                <td>12x18</td>
                <td>6.00</td>
              </tr>
              <tr>
                <td>16x20</td>
                <td>18.00</td>
              </tr>
              <tr>
                <td>18x24</td>
                <td>23.00</td>
              </tr>
              <tr>
                <td>20x24</td>
                <td>23.00</td>
              </tr>
              <tr>
                <td>20x30</td>
                <td>25.00</td>
              </tr>
              <tr>
                <td>24x30</td>
                <td>30.00</td>
              </tr>
              <tr>
                <td>24x36</td>
                <td>30.00</td>
              </tr>
              <tr>
                <td>30x40</td>
                <td>50.00</td>
              </tr>
            </tbody>
          </table>
          <p style={{ paddingTop: "10px" }}>
            Prints 12x18 and larger ship in a tube most of the time.
          </p>
        </div>

        <h2>Image Requirements</h2>
        <p>
          Your images must be RGB (not cmyk) and should be laid out at as 300ppi
          at the size ordered, with an attached color profile (sRGB ideally) and
          saved as a Standard (NOT progressive) jpg. Bleed is not needed, but
          the image will be cropped slightly on all 4 sides (2-4mm) so do not
          put text or other important subject matter right up to the edge of the
          image. If your image is not proportional to the size requested it will
          be center cropped. If your image has a border (like a white border)
          the border should be at least .25" on all sides - the machine blows up
          the image slightly and borders smaller than this will likely be
          visibly uneven due to small variances in the path of the paper as it
          is exposed.
        </p>
        <p>
          Please see our{" "}
          <a
            href="https://qprints.com/file-checker/"
            rel="noopener noreferrer"
            target="_blank"
          >
            File Requirements/File Checker
          </a>{" "}
          page on the main Qprints.com website for more information.
        </p>
        <h2>Prepping Information</h2>
        <p>
          If you are interested in our prepping service, please see this page
          for more information:
        </p>
        <p>
          {" "}
          <Link to="/prep">Prepping Service Notes</Link>
        </p>
        <h2>Copyright and Trademark Issues</h2>
        <p>
          Please do not send us images to print that are not one of the
          following: <br />
          1) Your own original work not based on any other prior work; <br />
          2) it is clearly in the public domain; <br />
          3) you have a license from the rights holder allowing you to use their
          artwork.
        </p>
        <p>
          For example, quotes from a famous athlete are most likely not in the
          public domain. We expect that you have done the research to know what
          is in the public domain and what is not and are not simply sending us
          things that are popular and sell well. Pointing us to the hundreds of
          other people selling the same thing does not prove that it is ok.
        </p>
        <p>
          If you have a question about an image please email it to us and ask
          what we think and we will let you know.
        </p>
        <p>
          Please make sure you have read and understand our{" "}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://qprints.com/policies/"
          >
            Terms of Use
          </a>
          .
        </p>
      </div>

      <div style={{ width: "600px", float: "right" }}>
        <h1>News and Updates</h1>
        <p>
          <b>
            10-1-2021 USPS Surcharge, Express Increase and Prep Surcharge
            Quantity Increased
          </b>
        </p>
        <p>
          Our rate for small Drop Ship orders has increased by $.30 to $9.25.
          This matches the increase that the post office is charging from
          October 1st thru December 26th. Priority Mail will be $13.50.
        </p>
        <p>
          The USPS is slowing down package delivery for First Class Packages as
          of 10/1/2021 - this effects shipments going long distances. This is
          changing from 1-3 days to 2-5 days.
        </p>
        <p>
          We are doing out best to get things to the post office in a timely
          matter, unfortunately we are at their mercy after that. We recommend
          you use Priority Mail if possible as we get closer to the holidays.
        </p>
        <p>
          Next Day Express for small orders under 1 pound is now $50, this is a
          permanent change.
        </p>
        <p>
          The Prep Surcharge Quantity has increased from 5 to 10. If you order
          less than 10 of any 1 mapping/sku there will be a $.15 surcharge per
          mapping/sku. Small quantities are very inefficient for us to process.
        </p>
        <p>
          <b>
            9-12-2021 USPS Surcharge, Priority Option, Express Increase, No More
            International
          </b>
        </p>
        <p>
          On October 1st the Post Office is going to apply a holiday peak rate
          increase of $.30 per First Class Package and between $.25 and $.75 for
          Priority. We are going to match this by increasing our rates. This
          will last until December 26th at which time we will reverse it.
        </p>
        <p>
          We have added a new drop ship shipping method for Priority Mail for
          $12.95. This is above the current Drop Ship Option which for small
          orders is for First Class Package service. We will keep that named as
          just Drop Ship. Last year when the Post Office melted down we thought
          that the Priority packages faired better. As we get closer to the
          holidays I would expect Priority Mail to fair much better than First
          Class. Please understand that while we plan to continue shipping
          orders within 24 hours we cannot control what the Post Office does
          after we drop it off. We highly recommend that you have a cut off for
          First Class Packages of December 1st or earlier. We will still offer
          it but you will be ordering at your own risk, no different than if you
          took the package to the Post Office yourself. If an order appears
          lost, please don't ask us to resend it for free, you will need to
          submit a new order and pay for it.
        </p>
        <p>
          We no longer offer International shipping for Etsy orders. We
          recommend that you do not allow international shipping on your Etsy
          account. If you do have an international order it should show as
          unfulfillable due to it being outside the US.
        </p>
        <p>
          We will increased our Express Shipping to $50 on October 1st. This is
          for small drop ship orders that are under 1 pound. This is also now an
          option when submitting an order outside of Etsy. Please note that UPS
          will only refund the shipping price if they do not deliver on time -
          and occasionally they do not deliver when promised. Saturday delivery
          not included. Orders received after 10am will likely ship the next
          day.
        </p>
        <p>
          <b>6-10-2021 Prep Surcharge Quantity Lowered</b>
        </p>
        <p>
          Our surcharge threshold for small quantities on prep orders has been
          lowered from 20 of the same mapping to 5. So as long as you order 5 or
          more of a mapping there will be no surcharge. If you order 4 or less
          of a mapping there will be a surcharge of $0.15.
        </p>
        <p>
          Our original purpose for the surcharge was to avoide shipments that
          get split into 3 - it seemed like that happens when the quantity of
          one sku was less than 20 but that doesn't seem to always be the case.
          If we find that your orders get split at a certain point we may ask
          you to pay amazon to not split them or pay our surcharge even if the
          quantity is above 5.
        </p>
        <p>
          <b>2-16-2021 Copyright and Trademark Issues</b>
        </p>
        <p>
          We have updated our
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://qprints.com/policies/"
          >
            Terms of Use
          </a>
          , though it is mostly the same as before. Please make sure you have
          read and understand them. Your continued use of our service means you
          agree to our Terms of Use.
        </p>
        <p>
          Please do not send us images to print that are not one of the
          following: 1) Your own original work not based on any other prior
          work; 2) it is clearly in the public domain; 3) you have a license
          from the rights holder allowing you to use their artwork.
        </p>
        <p>
          We ask that you review your images and make sure they meet these
          requirements. For example, quotes from a famous athlete are most
          likely not in the public domain. We expect that you have done the
          research to know what is in the public domain and what is not and are
          not simply sending us things that are popular and sell well. Pointing
          us to the hundreds of other people selling the same thing does not
          prove that it is ok.
        </p>
        <p>
          <b>1-11-2021 New Sales Tax Certificate for Marketplace Sellers</b>
        </p>
        <p>
          We have a new document that we need to have on file from each user -
          please fill out this{" "}
          <a href={Pdf} target="_blank">
            Marketplace Seller Certificate
          </a>{" "}
          and send it back to us. Even if we already have your resale
          certificate on file we would like to add this as it should cover us
          drop shipping orders to different states. We are still working on some
          sales tax changes, but hopefully this is all you will need to do for
          us to not charge you sales tax.
        </p>
        <p>
          If you have a resale license we would also like to have a{" "}
          <a href="https://qprints.com/qprints-multi-state-resale-cert.pdf">
            resale certificate
          </a>{" "}
          on file, if you have not done so already please fill that out as well.
        </p>
        <p>
          <b>1-9-2021 Shipping Price Increase</b>
        </p>
        <p>
          We will be increasing the price of shipping inside FBQ from $7.95 to
          $8.95 on January 15th.
        </p>
        <p>
          <b>10-29-2020 Prepping Service Now Available</b>
        </p>
        <p>
          We are now able to prep and ship your orders to Amazon. While we are
          still learning all of the ins and outs of it we are fairly comfortable
          with the process.
        </p>
        <p>Prep prices:</p>
        <ul>
          <li>8x10: $1.17 per sku</li>
          <li>11x14: $1.28 per sku</li>
          <li>Surcharge if less than 20 of a sku: $0.15 per sku</li>
        </ul>
        <p>
          There are no other fees. Shipping to Amazon is billed to your account.
        </p>
        <p>Limits: </p>
        <ul>
          <li>
            No minimum, but keep in mind the surcharge if there are less than 20
            of a sku, and that shipping to amazon still needs to be paid so it
            is best to spread that out with a full box (80 or so?)
          </li>
          <li>
            ~3000 sku maximum in one order. If you need more than that it is ok
            to submit additional orders, but we will alternate between clients
            if we are busy. You may also email us to ask if it is ok for more
            than that in one order.
          </li>
        </ul>
        <p>
          If you are interested in using our prep service please email us and
          let us know and we will tell you what you need to do. Please
          understand we are still learning the entire process, and things may
          change here and there.
        </p>
        <p>Turnaround time - usually a couple days to a week.</p>
      </div>
    </div>
  );
};

export default Home;
